import { render, staticRenderFns } from "./B-3-2__BUPageEdit.vue?vue&type=template&id=2b849c1e&"
import script from "./B-3-2__BUPageEdit.vue?vue&type=script&lang=js&"
export * from "./B-3-2__BUPageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports